<template>
    <header>
        <a
            href="https://xyx.web.sdo.com/web7/guide/default.aspx"
            target="_blank"
            class="logo"
        ></a>
        <!-- <div class="btn-video" @click="videoPlay"></div> -->
    </header>
    <Teleport to=".container">
        <div class="qwcode"></div>
        <Transition name="pop">
            <div id="videoPop" class="pop" v-if="state.show">
                <div class="content">
                    <span class="close" @click="closeVideo"></span>
                    <video
                        ref="videoRef"
                        controls="controls"
                        height="500"
                        width="886"
                        src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/hot.mp4"
                    ></video>
                </div>
            </div>
        </Transition>
    </Teleport>
</template>

<script setup>
import { reactive, ref, nextTick } from "vue";
const videoRef = ref(null);

const state = reactive({
    show: false
});
const videoPlay = () => {
    state.show = true;
    CsGame.eventRecord(1, "视频播放");
    nextTick(() => {
        videoRef.value.play();
    });
};
const closeVideo = () => {
    videoRef.value.pause();
    state.show = false;
};
</script>

<style lang="scss" scoped>
@keyframes Bigger {
    from {
        transform: scale(0.88);
    }

    to {
        transform: scale(1);
    }
}
header {
    background-image: url("https://static.web.sdo.com/xyx/pic/act/2026/0902_Join/1.jpg");
    position: relative;
    height: 1080px;
    &::before {
        position: absolute;
        content: "";
        background: url("https://static.web.sdo.com/xyx/pic/act/2026/0902_Join/title.png");
        width: 1197px;
        height: 295px;
        bottom: 104px;
        left: 50%;
        margin-left: -600px;
        animation: bounceIn 0.6s ease-in-out both;
    }
    .logo {
        background: url("https://static.web.sdo.com/xyx/pic/act/2025/0902_Baidu/logo.png");
        position: absolute;
        width: 176px;
        height: 101px;
        left: 40px;
        top: 20px;
        z-index: 2;
    }
    .btn-video {
        position: absolute;
        z-index: 3;
        width: 86px;
        height: 92px;
        left: 50%;
        margin-left: 290px;
        top: 550px;
        cursor: pointer;
        animation: Bigger 0.4s ease-in-out infinite alternate;
        background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/video-btn.png");
    }
}
.qwcode {
    position: fixed;
    z-index: 2;
    width: 163px;
    height: 289px;
    left: 20px;
    bottom: 40px;
    background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/qw-code.png");
}
#videoPop {
    .content {
        padding: 0px;
        width: 890px;
        height: 504px;
        border: 2px solid #f3ae0d;
    }
}
@media only screen and (min-width: 1920px) {
    .qwcode {
        left: 50%;
        margin-left: -960px;
    }
}
</style>
